import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/shared/lib/apiClient";

export const rosterKeys = {
  users: ["users"] as const,
};

export const usersQueryOptions = queryOptions({
  queryKey: rosterKeys.users,
  queryFn: async () => unwrap(await api.GET("/api/users")),
});
